import { type FC } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import clsx from 'clsx';
import { IconArrowUpRight, IconFileTypePdf, IconScale } from '@tabler/icons-react';
import { useGetOppositionBases } from '../../../../services/oppositionBase';
import { useTheme } from '../../../../contexts/ThemeContext';
import './OppositionBasesBanner.scss';

const OppositionBasesBanner: FC = () => {
  const { theme } = useTheme();
  const { oppositionBases, loading } = useGetOppositionBases();
  const latestBase = oppositionBases?.[0];

  if (loading || !latestBase?.fileUrl) {
    return null;
  }

  const publishedAt = latestBase.createdAt
    ? format(new Date(latestBase.createdAt), "d 'de' MMMM yyyy", { locale: es })
    : null;

  return (
    <section
      className={clsx('opposition-bases-banner', theme === 'dark' && 'opposition-bases-banner--dark')}
      aria-label="Últimas bases de la oposición publicadas"
    >
      <div className="opposition-bases-banner__texture" aria-hidden="true" />
      <div className="opposition-bases-banner__accent" aria-hidden="true" />

      <div className="opposition-bases-banner__content">
        <div className="opposition-bases-banner__meta">
          <span className="opposition-bases-banner__eyebrow">
            <IconScale size={13} stroke={1.75} aria-hidden="true" />
            Bases de la oposición
          </span>
          {publishedAt && (
            <time className="opposition-bases-banner__date" dateTime={latestBase.createdAt}>
              {publishedAt}
            </time>
          )}
        </div>

        <h2 className="opposition-bases-banner__title">{latestBase.name}</h2>

        {latestBase.description && (
          <p className="opposition-bases-banner__description">{latestBase.description}</p>
        )}
      </div>

      <a
        href={latestBase.fileUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="opposition-bases-banner__cta cursor-pointer"
      >
        <IconFileTypePdf size={16} stroke={1.75} aria-hidden="true" />
        Consultar PDF
        <IconArrowUpRight size={15} stroke={2} aria-hidden="true" />
      </a>
    </section>
  );
};

export { OppositionBasesBanner };
